export const VideoData = [
    {
        id:'1',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/p170977_p_v7_ae.jpeg',
    },
    {
        id:'2',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Hendrix Stamp',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/frozen1.jpg',
    },
    {
        id:'3',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Stephen Grider',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/black-panther-2_-marvel-studio-reveals-what-to-expect-from-the-film.jpg',
    },
    {
        id:'4',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Mohannad Zitoun',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/MV5BMTk0NjM3MDk3NV5BMl5BanBnXkFtZTgwNTEzNTY3MDE@._V1_.jpg',
    },
    {
        id:'5',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/81gW7li-v1L._RI_.jpg',
    },
    {
        id:'6',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Surfiya Zakir',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/p17232125_p_v8_ab.jpg',
    },
    {
        id:'7',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/81sJJlnmP8L._AC_SY445_.jpg',
    },
    {
        id:'1',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Surfiya Zakir',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/season-1.jpeg',
    },
    {
        id:'8',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/E6XN6YjXIAorjq_.jpg',
    },
    {
        id:'9',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Surfiya Zakir',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/pearl-2022.format.jpg',
    },
    {
        id:'10',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/il_570xN.3019128433_2wnf.jpg',
    },
    {
        id:'11',
        imageUrl: 'user.png',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        name: 'Surfiya Zakir',
        email: 'support@gmail.com',
        bgImage: 'https://rivall.co.uk/wp-content/uploads/2022/11/image_fc5cb742.jpeg',
    },
    
]